import React from 'react';
import ReactDom from 'react-dom';

import CheckoutIdentification from '../Components/CheckoutIdentification/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';


export default function(document) {
  var elements = document.querySelectorAll('[data-react-component="cs-checkout-identification"]');

  if (elements && elements.length) {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];

      ReactDom.render(
        <ErrorBoundary>
          <CheckoutIdentification />
        </ErrorBoundary>,
        element
      );
    }
  }
};

